// extracted by mini-css-extract-plugin
export default {"matches-card":"Matches_matches-card__V-sNN","badges-container":"Matches_badges-container__QvqW0"};